import { useTranslations } from '@/i18n/use-translations';
import { useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { embedTransport, embedSearch } from '@/lib/agents-embed';
import { Button } from '@/components/ui/button';

export function AgentsEmbedLayout() {
  const t = useTranslations('agents.embed');
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const nextSearch = embedSearch(search);
    if (nextSearch !== search) navigate({ pathname, search: nextSearch }, { replace: true });
  }, [pathname, search, navigate]);
  // A link outside the editor never opens another configuration surface.
  if (!/^\/agents(?:\/new|\/[^/]+(?:\/(?:behavior|advanced|edit|test))?)?$/.test(pathname)) {
    return <p role="alert">{t('noDisponible')}</p>;
  }
  return <div className="fixed inset-0 flex flex-col">
    <header className="shrink-0 border-b border-border px-4 py-2">
      <Button variant="ghost" onClick={() => embedTransport().close()}>{t('volver')}</Button>
    </header>
    <main className="flex-1 min-h-0 overflow-y-auto"><Outlet /></main>
  </div>;
}
